import { render, staticRenderFns } from "./cam-nang.vue?vue&type=template&id=092308a8"
import script from "./cam-nang.vue?vue&type=script&lang=js"
export * from "./cam-nang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports